module.exports = __webpack_public_path__ + "media/images/icons/certificate-545e673eee4070940c672200356fa290.svg";